/** @import assets */

import "../../../Styles/Orders.css";

/** @module Hooks */

import { useTranslation } from "react-i18next";

/** @module Components */

import { Link } from "react-router-dom";

/** @module React-Icons */

import { BsFillCalendar2WeekFill } from "react-icons/bs";

/**
 * 
 * @param {title, children} param0 
 * 
 * @returns checkout layout component
 * 
 */

const CheckoutLayout = ( { title, children } ) => { const 

    { t } = useTranslation ();

    /** Return component */

    return ( <div className="content checkout">
    
        <div className="layout">

            <section>{ children }</section>

        </div>
    
    </div> );

}

/** Export component */
 
export default CheckoutLayout;